import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { DropdownButton } from '@sendgrid/ui-components';
import dollarize, { formatIpString } from '../utils/displayHelpers';
import withAddOns from '../containers/withAddOns';
import AddonOption from './AddonOption';
import Styles from './ipselector.module.scss';
import BtnStyles from './summarybutton.module.scss';
import { ADDONS } from '../constants';

const numIps = [0, 1];
export class IpSelector extends Component {
  constructor(props) {
    super(props);
    this.handleIpClick = this.handleIpClick.bind(this);
  }

  handleIpClick(num) {
    this.props.addAddons({ [ADDONS.DEDICATED_IP]: num });
  }

  renderIps() {
    return (
      <Fragment> {numIps.map(n => (
        <AddonOption
          onClick={this.handleIpClick}
          datarole={`ipopt-${n}`}
          key={n}
          className={Styles.option}
          num={n}
          type="ip"
        >
          <div className={Styles.option}>
            <span className={Styles['addon-label']}>{formatIpString(n)}</span>
            <span className={Styles['addon-cost']}>{dollarize(n * ADDONS.IP_COST)}</span>
          </div>
        </AddonOption>))}
      </Fragment>
    );
  }


  render() {
    return (
      <div className={`${BtnStyles['btn-signup']} ip-select-container`}>
        <DropdownButton
          label={<div id="active-ip">{formatIpString(this.props.addOns[ADDONS.DEDICATED_IP])}</div>}
          type="primary"
          small
          id="ipdropdown"
          disabled={this.props.location.pathname.indexOf('billing') > -1}
          data-role="ip-dropdown"
        >
          {this.renderIps()}
        </DropdownButton>
      </div>
    );
  }
}

IpSelector.propTypes = {
  addAddons: PropTypes.func.isRequired,
  addOns: PropTypes.shape({
    [ADDONS.DEDICATED_IP]: PropTypes.number.isRequired,
    [ADDONS.EASE]: PropTypes.number.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(withAddOns(IpSelector));



// WEBPACK FOOTER //
// ./src/components/IpSelector.jsx